import React, { useEffect, useMemo, useRef, useState } from "react";
import "./careerValue.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { getCareerAboutOverview } from "../Service/CareerApi";
import { API_BASE_IMG_URl } from "helper/environment";
import TypedText from "components/Homes/typewrite";
import { useLocation } from "react-router-dom";
import Breadcrumb from "components/Breadcrumb";
const CAREER_ABOUT_UUID = "0b32014f-2f0f-4cde-82e4-872119371898";
// Core values dataset matching the top section grid layout of image_414980.png

export default function CoreValuesAndLeadership() {
  const [node, setNode] = useState<any>(null);
  const [included, setIncluded] = useState<any[]>([]);
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState<boolean>(false);

  const [activeValue, setActiveValue] = useState(0);

  const swiperRefs = useRef<any[]>([]);
  const prevRefs = useRef<any[]>([]);
  const nextRefs = useRef<any[]>([]);

  // ✅ separate counters per swiper
  const [activeGroups, setActiveGroups] = useState<any>({});
  const [totalGroups, setTotalGroups] = useState<any>({});
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    //console.log("CareerAbout component mounted");

    getCareerAboutOverview(CAREER_ABOUT_UUID)
      .then((res: any) => {
        //  console.log("CareerAbout API response:", res);
        setNode(res.data);
        setIncluded(res.included || []);
      })
      .catch(console.error);
  }, []);
  useEffect(() => {
    if (!location.hash) return;

    const scrollToHash = () => {
      const element = document.querySelector(location.hash);

      if (element) {
        const y =
          element.getBoundingClientRect().top + window.pageYOffset - 120;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      } else {
        // try again if element not yet rendered
        requestAnimationFrame(scrollToHash);
      }
    };

    scrollToHash();
  }, [location.hash]);
const getMinHeight = (text: string) => {
  if (text.length < 50) return 40;   // short text
  if (text.length < 100) return 70;  // medium text
  return 100;                         // long text
};


  //  Stop rendering until data exists
  if (!node) {
    return null; // or loader
  }
  const cards = node.relationships.field_driven_grow_power_data?.data || [];
 
  const getImageFromMedia = (mediaId?: string) => {
    if (!mediaId) return { url: null, alt: null };

    const media = included?.find(
      (inc: any) =>
        (inc.type === "media--image" || inc.type === "media--svg_image") &&
        inc.id === mediaId,
    );

    if (!media) return { url: null, alt: null };

    // check both possible relationship fields
    const imageField =
      media.relationships?.field_media_image?.data ||
      media.relationships?.field_media_svg_image?.data;

    const fileId = imageField?.id;

    const altText = imageField?.meta?.alt || media.attributes?.name || "";

    const file = included?.find(
      (inc: any) =>
        (inc.type === "file--file" ||
          inc.type === "file--image" ||
          inc.type === "media--svg_image") &&
        inc.id === fileId,
    );

    const fileUrl = file?.attributes?.uri?.url
      ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
      : null;

    return {
      url: fileUrl,
      alt: altText,
    };
  };
  const featureImages = node.relationships.field_featureimage?.data || [];



  // ✅ Counter update
  const updateCounter = (swiper: any, index: number) => {
    if (!swiper) return;

    const slidesPerGroup = swiper.params.slidesPerGroup || 1;

    const realSlidesCount = swiper.slides.filter(
      (slide: any) => !slide.classList.contains("swiper-slide-duplicate"),
    ).length;

    const currentGroup = Math.floor(swiper.realIndex / slidesPerGroup) + 1;

    const total = Math.ceil(realSlidesCount / slidesPerGroup);

    setActiveGroups((prev: any) => ({
      ...prev,
      [index]: currentGroup,
    }));

    setTotalGroups((prev: any) => ({
      ...prev,
      [index]: total,
    }));
  };

  return (
    <div id="Overview" className="corporate-values-wrapper font-sans">
      {/* SECTION 1: CORE VALUES BANNERS (Green Top Header) */}
      <section className="values-banner position-relative overflow-hidden  text-white">
        {/* Background Subtle Graphic Wave Accent */}

        <Breadcrumb />
        <div className="container career-card-about">
          <div className="row gx-2">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div
                className="section-title  text-center mx-auto mb-5 mt-3 wow fadeInUp clearfix"
                data-wow-delay="0.1s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
              >
                <h6>{node?.attributes?.field_subtitle || ""}</h6>
                <h2 className="mb-4 text-white">
                  {node?.attributes?.field_maintitle}
                  {/* <TypedText
                                             index={1}
                                             text={`<span class='text-white'>${node?.attributes?.field_maintitle.replace(/&amp;/g, "&")}</span>`}
                                             delay={100}
                                             cursor="|"
                                           /> */}
                </h2>
              </div>
            </div>{" "}
          </div>

          {/* Flexible Multi-card Value Row Grid Layout */}
          <div className="row g-4 mt-3 mb-2 justify-content-center align-items-stretch" data-wow-delay="0.4s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
            {cards.map((item: any, index: number) => {
              const isActive = activeValue === index;
              const para = included.find(
                (i) =>
                  i.type === "paragraph--about_vision_mission_content" &&
                  i.id === item.id,
              );
              const image = getImageFromMedia(
                para?.relationships.field_icon?.data?.id,
              );

              return (
                <div
                  key={item.id}
                  className="col-12 col-sm-6 col-md-4 col-lg  d-lg-block d-none d-md-none "
                  onMouseEnter={() => setActiveValue(index)}
                >
                  <div
                    className={`value-square-card d-flex flex-column align-items-center justify-content-center p-4  text-center ${isActive ? "active shadow-lg" : ""}`}
                  >
                    <div className="value-icon-box mb-3">
                      <img
                        src={image?.url || ""}
                        alt={image?.alt || "Overview"}
                        className="img-fluid"
                      />
                    </div>
                    <h6 className="fw-bold mb-0 value-title">
                      {para?.attributes?.field_title || ""}
                    </h6>

                    {/* Collapsible details depending on selected focus node */}
                    <div
                      className={`value-desc-collapse mt-3 ${isActive ? "expanded" : ""}`}
                    >
                      <p
                        className="small mb-0 opacity-1 "
                        dangerouslySetInnerHTML={{
                          __html:
                            para?.attributes?.field_descriptions?.value || "",
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="row g-4 justify-content-center align-items-stretch d-lg-none d-block d-md-block">
            {cards?.length > 0 && (
              <Swiper
                modules={[Navigation]}
                navigation={false} // ✅ MUST ENABLE
                loop={true}
                // autoplay={{ delay: 8000, disableOnInteraction: false }} // ✅ autoplay working
                slidesPerView={1}
                spaceBetween={20}
                breakpoints={{
                  0: { slidesPerView: 1, slidesPerGroup: 1 },
                  768: { slidesPerView: 3, slidesPerGroup: 3 },
                  992: { slidesPerView: 5, slidesPerGroup: 5 },
                }}
                onSwiper={(swiper: any) => {
                  swiperRefs.current[0] = swiper;

                  setTimeout(() => {
                    const prevEl = prevRefs.current[0];
                    const nextEl = nextRefs.current[0];

                    if (!swiper || !swiper.params) return;
                    if (!prevEl || !nextEl) return;

                    // ✅ assign navigation safely
                    swiper.params.navigation.prevEl = prevEl;
                    swiper.params.navigation.nextEl = nextEl;

                    // ✅ re-init navigation
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.navigation.update();
                  }, 100);
                }}
                onSlideChange={(swiper: any) => updateCounter(swiper, 0)}
                className="career-swiper"
              >
                {cards.map((item: any, index: any) => {
                  const isActive = activeValue === item.id;
                  const para = included.find(
                    (i) =>
                      i.type === "paragraph--about_vision_mission_content" &&
                      i.id === item.id,
                  );
                  const image = getImageFromMedia(
                    para?.relationships.field_icon?.data?.id,
                  );
                  return (
                    <SwiperSlide key={index}>
                      <div
                        key={item.id}
                        className="col-12 col-sm-12 col-md-12 col-lg-12"
                        onMouseEnter={() => setActiveValue(item.id)}
                      >
                        <div
                          className={`value-square-card d-flex flex-column mx-2 align-items-center justify-content-center p-4 text-center `}
                        >
                          <div className="value-icon-box mb-3">
                            <img
                              src={image?.url || ""}
                              alt={image?.alt || "Overview"}
                              className="img-fluid"
                            />
                          </div>
                          <h5 className="fw-bold mb-0 value-title">
                            {para?.attributes?.field_title || ""}
                          </h5>

                          {/* Collapsible details depending on selected focus node */}
                          <div  className={`value-desc-collapse mt-3 expanded `}  >
                            <p
                              className="small mb-0 opacity-1 text-dark"
                              dangerouslySetInnerHTML={{
                                __html:
                                  para?.attributes?.field_descriptions?.value ||
                                  "",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}

                {totalGroups[0] > 1 && (
                  <div className="d-flex justify-content-center opacity-0 align-items-center gap-4 ">
                    <span
                      ref={(el: any) => (prevRefs.current[0] = el)}
                      className="cursor-pointer swiper-arrow"
                    >
                      <i className="bi bi-arrow-left"></i>
                    </span>

                    <div className="fw-semibold">
                      {activeGroups[0] || 1} / {totalGroups[0] || 1}
                    </div>

                    <span
                      ref={(el: any) => (nextRefs.current[0] = el)}
                      className="cursor-pointer swiper-arrow"
                    >
                      <i className="bi bi-arrow-right"></i>
                    </span>
                  </div>
                )}
              </Swiper>
            )}
            {totalGroups[0] > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-4 mt-2 pb-5">
                <span
                  ref={(el: any) => (prevRefs.current[0] = el)}
                  className="cursor-pointer swiper-arrow"
                >
                  <i className="bi bi-arrow-left"></i>
                </span>

                <div className="fw-semibold">
                  {activeGroups[0] || 1} / {totalGroups[0] || 1}
                </div>

                <span
                  ref={(el: any) => (nextRefs.current[0] = el)}
                  className="cursor-pointer swiper-arrow"
                >
                  <i className="bi bi-arrow-right"></i>
                </span>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
